export default class SettingsSidebar {
  static selectorString() {
    return '.SettingsSidebar';
  }

  render(node, props) {
    const trigger = node.querySelector('#show-edit-settings-sidebar');
    trigger.addEventListener('click', this.showEditView.bind(this));

    const resetTrigger = node.querySelector('#reset_form');
    resetTrigger.addEventListener('click', this.hideEditView.bind(this));

    const saveTrigger = node.querySelector('#save_form');
    saveTrigger.addEventListener('click', this.saveEditView.bind(this));
  }

  showEditView() {
    this.node.querySelector('#settings-sidebar-display').classList.add('hide');
    this.node.querySelector('#settings-sidebar-display').classList.remove('show');

    this.node.querySelector('#settings-sidebar-edit').classList.remove('hide');
    this.node.querySelector('#settings-sidebar-edit').classList.add('show');
  }

  hideEditView() {
    this.node.querySelector('#settings-sidebar-display').classList.remove('hide');
    this.node.querySelector('#settings-sidebar-display').classList.add('show');

    this.node.querySelector('#settings-sidebar-edit').classList.add('hide');
    this.node.querySelector('#settings-sidebar-edit').classList.remove('show');
  }

  saveEditView() {
    // TODO: validate
  }
}
